(() => {
  const selector = '.product__media-wrapper--smart-sticky';
  const desktopBreakpoint = 990;
  const gap = 24;
  const observed = new WeakSet();

  const update = (element) => {
    if (window.innerWidth < desktopBreakpoint) {
      element.style.removeProperty('--todamu-media-sticky-top');
      return;
    }

    const height = element.getBoundingClientRect().height;
    const top = Math.min(gap, window.innerHeight - height - gap);
    element.style.setProperty('--todamu-media-sticky-top', `${Math.round(top)}px`);
  };

  const initElement = (element) => {
    update(element);
    if (observed.has(element)) return;
    observed.add(element);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => update(element));
      observer.observe(element);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll(selector).forEach(initElement);
  };

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => document.querySelectorAll(selector).forEach(update), 80);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
